import { Directive, effect, input, OnChanges } from '@angular/core';
import { Input } from '@angular/core';
import { FwAvatarComponent, FwTooltipDirective } from '@flywheel-io/vision';

import { User } from '../models/user.model';

/**
 * accepts a user and maps it to the inputs of `FwAvatar`
 * @Usage
 * `<fw-avatar [appUser]="profile$ | async"</fw-avatar>`
 */
@Directive({
  selector: '[appUser]',
  hostDirectives: [FwTooltipDirective],
})
export class AppUserDirective implements OnChanges {
  constructor(
    private host: FwAvatarComponent,
    private tooltip: FwTooltipDirective
  ) { }

  @Input() appUser: User;
  tooltipEnabled = input(false, {
    alias: 'appUserTooltip',
  })

  tooltipChanges = effect(() => {

    if (!this.tooltipEnabled()) {
      this.tooltip.enabled.set(false);
      return;
    }


    const fullName = `${this.appUser.firstname} ${this.appUser.lastname}`
    const email = this.appUser.email || this.appUser._id;

    let tooltipString = fullName;

    if (email) {
      tooltipString = tooltipString.concat(`\n${email}`);
    }

    this.tooltip.title.set(tooltipString);
  }, { allowSignalWrites: true })

  ngOnChanges(): void {

    if (!this.appUser || !this.appUser.firstname || !this.appUser.lastname) {
      return;
    }

    this.host.content = this.appUser.avatar ? 'image' : 'initial';
    this.host.imageUrl = this.appUser.avatar;
    const initials = this.appUser.firstname[0] + this.appUser.lastname[0];
    this.host.initial = initials;
    this.host.colorSeed.set(initials);
  }
}
